
export default function RelatedLinks() {
  const links = [
    {
      name: 'みやぎスマイルケアネットワーク',
      url: 'https://miyagi-smile-care.net/',
      icon: 'ri-heart-pulse-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
    },
    {
      name: 'きらり保育園仙台六丁の目',
      url: 'https://kirari-sendai.jp/',
      icon: 'ri-home-heart-line',
      iconBg: 'bg-pink-100',
      iconColor: 'text-pink-600',
    },
    {
      name: 'きらり小児訪問看護ステーション',
      url: 'https://kirari-kango.jp/',
      icon: 'ri-nurse-line',
      iconBg: 'bg-teal-100',
      iconColor: 'text-teal-600',
    },
    {
      name: '認定NPO法人フローレンス',
      url: 'https://florence.or.jp/',
      icon: 'ri-hand-heart-line',
      iconBg: 'bg-amber-100',
      iconColor: 'text-amber-600',
    },
  ];

  return (
    <div className="bg-gradient-to-br from-teal-50 to-cyan-50 py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h3 className="text-lg font-bold text-gray-800 mb-6 text-center flex items-center justify-center space-x-2">
          <i className="ri-links-line text-teal-600"></i>
          <span>関連リンク</span>
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {links.map((link) => (
            <a
              key={link.url}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-3 bg-white rounded-xl p-4 shadow-sm hover:shadow-md transition-all cursor-pointer group"
            >
              <div className={`w-10 h-10 ${link.iconBg} rounded-lg flex items-center justify-center flex-shrink-0`}>
                <i className={`${link.icon} ${link.iconColor} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-gray-800 group-hover:text-teal-600 transition-colors text-sm">
                  {link.name}
                </p>
              </div>
              <i className="ri-external-link-line text-gray-400 group-hover:text-teal-600 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
